import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { getCategoryTitle } from '@classifieds-sell/datalayer';
import { Subject } from 'rxjs';
import { getFullAddress } from '../../../helpers/address.helper';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-summary-page-property-information-section',
    templateUrl: './summary-page-property-information-section.component.html',
    styleUrls: ['./summary-page-property-information-section.component.scss']
})
export class SummaryPagePropertyInformationSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    category: string;
    address: string;
    bedrooms: string;
    bathrooms: string;
    ensuites: string;
    lounges: string;
    toilets: string;
    studies: string;
    garageParking: string;
    offStreetParking: string;
    parkingDetail: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.category = getCategoryTitle(this.categoryId);

            this.address = getFullAddress(
                this.draftData.propertyInformation,
                this.metadata.regions
            );

            this.bedrooms = this.metadata.bedrooms.find(x => x.value === this.draftData.propertyInformation.bedrooms)?.display;

            if (this.draftData.propertyInformation.bathrooms === 6) {
                this.bathrooms =
                    this.draftData.propertyInformation.bathrooms + '+';
            } else {
                this.bathrooms = this.draftData.propertyInformation.bathrooms;
            }

            if (this.draftData.propertyInformation.ensuites === 6) {
                this.ensuites =
                    this.draftData.propertyInformation.ensuites + '+';
            } else {
                this.ensuites = this.draftData.propertyInformation.ensuites;
            }

            if (this.draftData.propertyInformation.lounges === 6) {
                this.lounges =
                    this.draftData.propertyInformation.lounges + '+';
            } else {
                this.lounges = this.draftData.propertyInformation.lounges;
            }
            if (this.draftData.propertyInformation.toilets === 6) {
                this.toilets =
                    this.draftData.propertyInformation.toilets + '+';
            } else {
                this.toilets = this.draftData.propertyInformation.toilets;
            }
            if (this.draftData.propertyInformation.studies === 6) {
                this.studies =
                    this.draftData.propertyInformation.studies + '+';
            } else {
                this.studies = this.draftData.propertyInformation.studies;
            }
            if (this.draftData.propertyInformation.garageParking === 6) {
                this.garageParking =
                    this.draftData.propertyInformation.garageParking + '+';
            } else {
                this.garageParking = this.draftData.propertyInformation.garageParking;
            }
            if (this.draftData.propertyInformation.offStreetParking === 6) {
                this.offStreetParking =
                    this.draftData.propertyInformation.offStreetParking + '+';
            } else {
                this.offStreetParking = this.draftData.propertyInformation.offStreetParking;
            }
            this.parkingDetail = this.draftData.propertyInformation.parkingDetail;

            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
